import { useState, useEffect, useContext } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import BackButtonWhite from "../../../assets/image/BackButtonWhite";
import { getApi } from "../../../utils/services";
import { BASE_IMAGE_URL } from "../../../utils/services";
import { VIEW_PETTYCASH_BILL } from "../../../utils/apiRoutes";
import moment from "moment/moment";
import { Helmet } from "react-helmet";
import Loader from "../../common/Loader";
import { ModalContext } from "../../../utils/Context";
import { ADMIN_MANAGER_ID, FINANCE_ID, FINANCE_PENDING, PAYMENT_PENDING, SUPER_ADMIN_ID, VENDORID, VENDOR_MANAGER_PENDING, VENDOR_VP_PENDING, VP_ID, FULLY_PAID, VENDOR_REJECT, STANDALONE_BILL_APPROVE_ID, PETTY_CASH_APPROVE_ID } from "../../../utils/constant";
import PaymentModal from "../../modal/PaymentModal";
import RejectionModal from "../../modal/RejectionModal";
import { handleApproval } from "../../../utils/helpers/globalMethod";
import BillToContent from "../../common/BillToContent";
import SystemInfo from "../vendor/SystemInfo";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import exporticon from "../../../assets/image/Excel_Download_Icon.png";

const ViewPettyCashBill = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const user = JSON.parse(localStorage.getItem("userData"));
    const [Viewdetails, setViewDetails] = useState({});
    const [showbackButton, setShowbackButton] = useState(false);
    const [loader, setLoader] = useState(false);
    const modalContext = useContext(ModalContext);
    const { handleModalData } = modalContext;
    const [pettyCashBillHistory, setPettyCashBillHistory] = useState([]);

    useEffect(() => {
        handlePettyCashViewdetails();
    }, []);

    useEffect(() => {
        if (window.history.length > 1) {
            setShowbackButton(true);
        } else {
            setShowbackButton(false)
        }
    }, []);

    const handleGoBack = () => {
        navigate(-1)
    }

    const handlePettyCashViewdetails = async () => {
        try {
            setLoader(true);
            const result = await getApi(`${VIEW_PETTYCASH_BILL}/${id}`);
            setLoader(false);
            setViewDetails(result.res.pettyCash_details);
            const updatedHistory = result?.res.pettyCashHistory?.map((item) => {
                const utcTime = item.ModifiedAt;
                const date = new Date(utcTime);
                const formattedTime = date.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });
                return { ...item, ModifiedAt: formattedTime };
            }) || [];
            setPettyCashBillHistory(updatedHistory);
        } catch (error) {
            console.log(error);
        }
    };

    let data = {
        id: Number(id),
    };

    const handleApprove = () => {
        handleApproval(data, handleModalData, handlePettyCashViewdetails, PETTY_CASH_APPROVE_ID);
    };

    const handleReject = () => {
        let reject = (
            <RejectionModal
                data={Viewdetails}
                handlerPettyCashList={handlePettyCashViewdetails}
                billType={Viewdetails.BillType}
            />
        );
        handleModalData(reject, "reject");
    };

    const handlePayment = () => {
        const payment = <PaymentModal item={Viewdetails} id={id} handleView={handlePettyCashViewdetails} />;
        handleModalData(payment, "md");
    }

    const getPreviewLink = (filePath) => {
        const extension = filePath.split('.').pop().toLowerCase();
        const encodedPath = btoa(filePath);

        if (extension === 'pdf') {
            return `/preview-pdf/${encodedPath}`;
        } else if (['jpg', 'jpeg', 'png'].includes(extension)) {
            return `/preview-image/${encodedPath}`;
        }
        return '#';
    };

    const handleExportItemData = () => {
        if (!Viewdetails?.InvoiceLines || Viewdetails?.InvoiceLines.length === 0) {
            return;
        }

        const formattedBillDate = moment(Viewdetails?.BillDate).format("D/MM/YYYY");

        const headerData = [
            ['Bill No:', Viewdetails.InvDocumentNo || 'N/A', '', '', '', 'Bill Date:', formattedBillDate || 'N/A'],
            ['Vendor:', 'Prospect Vendor', '', '', '', 'Status:', Viewdetails.StatusName || 'N/A'],
            [],
        ];

        const tableHeader = [
            'Bill Date',
            'Vendor Name',
            'Item',
            'Description',
            'Department',
            'Amount',
            'Comment'
        ];

        const itemData = Viewdetails.InvoiceLines.map(item => [
            moment(item.BillDate).format("D/MM/YYYY"),
            item.VendorName,
            item.ItemName,
            item.Description || 'N/A',
            item.DepartmentName,
            `${item?.Amount?.toFixed(2)}`,
            item?.Comment || 'N/A'
        ]);

        const totalAmount = Viewdetails?.Total?.toFixed(2) || '0.00';

        const csvData = [
            ...headerData,
            tableHeader,
            ...itemData,
            [],
            ['', '', '', '', 'Total:', `${totalAmount}`, '']
        ];

        const csvContent = csvData.map(row =>
            row.map(field => `"${field.toString().replace(/"/g, '""')}"`).join(',')
        ).join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `PettyCashItemDetails.csv`;
        link.click();
        URL.revokeObjectURL(url);
    };

    return (
        <>
            <Helmet>
                <title>Vendor Portal || View Petty Cash Bill</title>
            </Helmet>
            <Loader isLoading={loader} />
            {
                (user?.RoleId === SUPER_ADMIN_ID && Viewdetails.StatusId === PAYMENT_PENDING) && (
                    <div className="d-flex justify-content-end">
                        <span className="success-btn mb-2">
                            <button className="btn" onClick={handlePayment}>Make Payment</button>
                        </span>
                    </div>)
            }
            <div className="container-section">

                <div className="section-inv-header">
                    <div className="d-flex align-items-center justify-content-between w-100">
                        {showbackButton && (
                            <button onClick={handleGoBack} className="back-viewbtn me-1">
                                <div className="svgsize">
                                    <BackButtonWhite />
                                </div>
                            </button>
                        )}

                        <h3 className="bill-header-title">Petty Cash Bill</h3>
                    </div>
                </div>

                <div className="form-style">
                    <div className="data-inv-info">
                        <div className="data-inv-group-1">
                            <BillToContent />
                            <div className="d-flex row flex-column align-items-between">
                                <div className="col-md-9">
                                    {user.RoleId !== VENDORID && (
                                        <div className="data-details-4">
                                            <div className="section-sub-heading">
                                                <h4>Integration:</h4>
                                            </div>
                                            <div className="d-flex align-items-center ">
                                                <span className=" data-label">NetSuite Id</span>
                                                <span className="data-semicolon">:</span>
                                                <span className="data-value">
                                                    {Viewdetails?.ExternalId ? Viewdetails?.ExternalId : " N/A"}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="data-inv-group-2">
                            <div className="data-details-4">
                                <div className="d-flex align-items-center mb-1">
                                    <span className="data-label">Bill#</span>
                                    <span className="data-semicolon">:</span>
                                    <span className="data-value pe-0">
                                        {Viewdetails.InvDocumentNo}
                                    </span>
                                </div>
                                <div className="d-flex align-items-center mb-1">
                                    <span className="data-label">Payment Mode</span>
                                    <span className="data-semicolon">:</span>
                                    <span className="data-value pe-0">Cash</span>
                                </div>

                                <div className="d-flex align-items-center mb-1">
                                    <span className="data-label">Bill Date</span>
                                    <span className="data-semicolon">:</span>
                                    <span className="data-value pe-0">
                                        {moment(Viewdetails?.BillDate)
                                            .format("D/MM/YYYY")
                                            ?.slice(0, 10)}
                                    </span>
                                </div>
                                <div className="d-flex align-items-center mb-1">
                                    <span className="data-label">Status</span>
                                    <span className="data-semicolon">:</span>
                                    <span className="data-value pe-0">
                                        {Viewdetails?.StatusName}
                                    </span>
                                </div>

                                {Viewdetails?.RejectionReason ? (
                                    <div className="d-flex rej-reason-box mb-1">
                                        <span className="data-label">Rejection Reason</span>
                                        <span className="data-semicolon">:</span>
                                        <span className="data-value pe-0">
                                            {Viewdetails.RejectionReason}
                                        </span>
                                    </div>
                                ) : (
                                    <div className="d-flex rej-reason-box mb-1">
                                        <span className="data-label">Rejection Reason</span>
                                        <span className="data-semicolon">:</span>
                                        <span className="data-value pe-0">N/A</span>
                                    </div>
                                )}
                                <div className="d-flex align-items-left mb-1">
                                    <span className="data-label">Allocated Funds</span>
                                    <span className="data-semicolon">:</span>
                                    <span className="data-value pe-0">
                                        {Viewdetails?.Funds?.length > 0
                                            ? Viewdetails.Funds.map(fund => fund.FundNo).join(", ")
                                            : "N/A"}
                                    </span>
                                </div>

                                  <div className="d-flex align-items-left mb-1">
                                    <span className="data-label">Total Bills Count</span>
                                    <span className="data-semicolon">:</span>
                                    <span className="data-value pe-0">
                                        {
                                             Viewdetails?.InvoiceLines?.length ?? "N/A"
                                            }
                                    </span>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>

                <div className="form-style">
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="section-sub-heading m-0">
                            <h3>Item Description</h3>
                        </div>
                        {Viewdetails?.InvoiceLines?.length > 0 && (
                            <div className='Export-Icon' onClick={handleExportItemData}>
                                <img src={exporticon} alt="Export to Excel" className='cursor-pointer' width="45" />
                            </div>
                        )}
                    </div>
                    <div className="table-responsive  tbl-body-shadow">
                        <table className="w-100 table-theme-1">
                            <thead>
                                <tr>
                                    <th className="text-left">Bill Date</th>
                                    <th className="text-left">Vendor Name</th>
                                    <th className="text-left">Item</th>
                                    <th className="text-left">Description</th>
                                    <th className="text-left">Department</th>
                                    <th className="text-end">Amount</th>
                                    <th className="text-left">Comment</th>
                                    <th className="text-center">File</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Viewdetails?.InvoiceLines &&
                                    Viewdetails?.InvoiceLines.length > 0 ? (
                                    Viewdetails.InvoiceLines.map((row, index) => (
                                        <tr key={index}>
                                            <td className="text-left text-nowrap">{row.BillDate}</td>
                                            <td className="text-left text-wrap">{row.VendorName}</td>
                                            <td className="text-left text-nowrap">{row.ItemName}</td>
                                            <td className="text-left text-wrap">{row.Description ? row.Description : "N/A"}</td>
                                            <td className="text-left text-wrap">{row.DepartmentName}</td>
                                            <td className="text-end text-nowrap">
                                                {Viewdetails.CurrencySymbol} {row?.Amount?.toFixed(2)}
                                            </td>
                                            <td className="text-left text-wrap">
                                                {row?.Comment ?
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip id="tooltip1">
                                                                {row?.Comment}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <div className="truncate-error-text">
                                                            {row?.Comment}
                                                        </div>
                                                    </OverlayTrigger>
                                                    :
                                                    <div className="truncate-error-text">N/A</div>
                                                }
                                            </td>
                                            <td className="text-center">
                                                {row.FileName ? (
                                                    <div className="d-flex align-items-center justify-content-center">
                                                        <span className="me-2">
                                                            <Link
                                                                to={`${BASE_IMAGE_URL}/${row.FilePath}`}
                                                                download
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                title="Download"
                                                            >
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="31"
                                                                    height="30"
                                                                    viewBox="0 0 31 30"
                                                                    fill="none"
                                                                >
                                                                    <rect
                                                                        width="30.4351"
                                                                        height="30"
                                                                        rx="6"
                                                                        fill="#F7CB73"
                                                                    />
                                                                    <path
                                                                        d="M15 19L10 14L11.4 12.55L14 15.15V7H16V15.15L18.6 12.55L20 14L15 19ZM9 23C8.45 23 7.979 22.804 7.587 22.412C7.195 22.02 6.99934 21.5493 7 21V18H9V21H21V18H23V21C23 21.55 22.804 22.021 22.412 22.413C22.02 22.805 21.5493 23.0007 21 23H9Z"
                                                                        fill="white"
                                                                    />
                                                                </svg>
                                                            </Link>
                                                        </span>
                                                        <span>
                                                            <Link
                                                                to={getPreviewLink(row.FilePath)}
                                                                target="_blank"
                                                                title="View"
                                                            >
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="31"
                                                                    height="30"
                                                                    viewBox="0 0 31 30"
                                                                    fill="none"
                                                                >
                                                                    <rect
                                                                        width="30.4351"
                                                                        height="30"
                                                                        rx="6"
                                                                        fill="#58BAE4"
                                                                    />
                                                                    <path
                                                                        d="M15.2785 9C10.1451 9 7.10156 15 7.10156 15C7.10156 15 10.1451 21 15.2785 21C20.2901 21 23.3336 15 23.3336 15C23.3336 15 20.2901 9 15.2785 9ZM15.2176 11C17.4698 11 19.2756 12.8 19.2756 15C19.2756 17.22 17.4698 19 15.2176 19C12.9857 19 11.1596 17.22 11.1596 15C11.1596 12.8 12.9857 11 15.2176 11ZM15.2176 13C14.1016 13 13.1886 13.9 13.1886 15C13.1886 16.1 14.1016 17 15.2176 17C16.3335 17 17.2466 16.1 17.2466 15C17.2466 14.8 17.1654 14.62 17.1248 14.44C16.9625 14.76 16.6379 15 16.2321 15C15.664 15 15.2176 14.56 15.2176 14C15.2176 13.6 15.4611 13.28 15.7857 13.12C15.6031 13.06 15.4205 13 15.2176 13Z"
                                                                        fill="white"
                                                                    />
                                                                </svg>
                                                            </Link>
                                                        </span>
                                                    </div>
                                                ) : (
                                                    <span>N/A</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center">
                                            No data found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="view-footer d-flex justify-content-end mt-2 mb-20">
                        <div className="data-details-3">
                            <div className=" view-total-amount d-flex align-items-center mt-3">
                                <span className=" data-label text-align-left">Total</span>
                                <span className="data-semicolon">:</span>
                                <span className="data-value">
                                    {Viewdetails.CurrencySymbol} {Viewdetails?.Total?.toFixed(2)}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {pettyCashBillHistory?.length > 0 && (
                    <div className="">
                        <SystemInfo viewHistory={pettyCashBillHistory} />
                    </div>
                )}

                {user?.RoleId === ADMIN_MANAGER_ID &&
                    Viewdetails.StatusId === VENDOR_MANAGER_PENDING && (
                        <div className="d-flex align-items-center justify-content-end mb-20 form-style pt-2">
                            <div className="danger-outline-btn ">
                                <button
                                    type="button"
                                    className="btn"
                                    onClick={handleReject}
                                >
                                    Reject
                                </button>
                            </div>
                            <div className="success-btn ms-2">
                                <button
                                    type="submit"
                                    className="btn"
                                    onClick={() => handleApprove()}
                                >
                                    Approve
                                </button>
                            </div>
                        </div>
                    )}

                {user?.RoleId === VP_ID &&
                    Viewdetails.StatusId === VENDOR_VP_PENDING && (
                        <div className="d-flex align-items-center justify-content-end mb-20 form-style pt-2">
                            <div className="danger-outline-btn ">
                                <button
                                    type="button"
                                    className="btn"
                                    onClick={handleReject}
                                >
                                    Reject
                                </button>
                            </div>
                            <div className="success-btn ms-2">
                                <button
                                    type="submit"
                                    className="btn"
                                    onClick={() => handleApprove()}
                                >
                                    Approve
                                </button>
                            </div>
                        </div>
                    )}

                {user?.RoleId === FINANCE_ID &&
                    Viewdetails.StatusId === FINANCE_PENDING && (
                        <div className="d-flex align-items-center justify-content-end mb-20 form-style pt-2">
                            <div className="danger-outline-btn ">
                                <button
                                    type="button"
                                    className="btn"
                                    onClick={handleReject}
                                >
                                    Reject
                                </button>
                            </div>
                            <div className="success-btn ms-2">
                                <button
                                    type="submit"
                                    className="btn"
                                    onClick={() => handleApprove()}
                                >
                                    Approve
                                </button>
                            </div>
                        </div>
                    )}

            </div>
        </>
    );
};

export default ViewPettyCashBill;